import { initializeApp, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  development: {
    apiKey: "AIzaSyC7VGUpjcpqMJOxYqcMGMjfbsLA5hymrxc",
    authDomain: "maxpro-dev.firebaseapp.com",
    databaseURL: "https://maxpro-dev.firebaseio.com",
    projectId: "maxpro-dev",
    storageBucket: "maxpro-dev.appspot.com",
    messagingSenderId: "452420342009",
    appId: "1:452420342009:web:b98604a8998589fe3f1228",
    measurementId: "G-43S47W7ZMT",
  },
  production: {
    apiKey: "AIzaSyDBEXnI06UCOjYmOefCJgQOZGtiCmPKehw",
    authDomain: "maxfit-app.firebaseapp.com",
    databaseURL: "https://maxfit-app.firebaseio.com",
    projectId: "maxfit-app",
    storageBucket: "maxfit-app.appspot.com",
    messagingSenderId: "278166805972",
    appId: "1:278166805972:web:d0a3ff9b30eaba64",
    measurementId: "G-KN07P98H3Y"
  },
}
// Determine environment based on hostname or environment variable
let currentENV;
currentENV = firebaseConfig.production;
// if (typeof window !== 'undefined') {
//   // Client-side: check hostname
//   if (window.location.hostname === 'localhost' || window.location.hostname.includes('dev')) {
//     currentENV = firebaseConfig.development;
//   } else {
//     currentENV = firebaseConfig.production;
//   }
// } else {
//   // Server-side: default to production
//   currentENV = firebaseConfig.production;
// }

// Initialize Firebase
try {
  console.log('Attempting to initialize Firebase with config:', {
    projectId: currentENV.projectId,
    authDomain: currentENV.authDomain,
    apiKey: currentENV.apiKey ? '***' + currentENV.apiKey.slice(-4) : 'undefined'
  });
  
  // Check if Firebase is already initialized
  try {
    const existingApp = getApp();
    console.log('Firebase app already exists:', existingApp.name);
    // Use the existing app
  } catch (e) {
    // No existing app, initialize new one
    initializeApp(currentENV);
    console.log('Firebase initialized successfully with environment:', currentENV.projectId);
  }
} catch (error) {
  console.error('Error initializing Firebase:', error);
  // Try to get more details about the error
  if (error.code) {
    console.error('Firebase error code:', error.code);
  }
  if (error.message) {
    console.error('Firebase error message:', error.message);
  }
}
// firebase.analytics();

// Lazy load Firebase services to ensure app is initialized
const getDb = () => {
  try {
    return getFirestore();
  } catch (error) {
    console.error('Error getting Firestore:', error);
    return null;
  }
};

const getAuthInstance = () => {
  try {
    console.log('Getting Firebase Auth instance...');
    const auth = getAuth();
    if (auth) {
      console.log('Firebase Auth instance obtained successfully');
    } else {
      console.error('getAuth() returned null/undefined');
    }
    return auth;
  } catch (error) {
    console.error('Error getting Auth:', error);
    return null;
  }
};

const apiKey = currentENV.apiKey
export {
  getDb,
  getAuthInstance,
  apiKey
}